import { createFileRoute, Outlet } from "@tanstack/react-router"

import HeaderTabs from "~/components/reusable/HeaderTabs"
import { useAllocationAccess } from "~/hooks/useAllocationAccess"

export const Route = createFileRoute("/_auth/allocation/_layout/reports")({
  component: RouteComponent,
})

function RouteComponent() {
  const { reportTabs } = useAllocationAccess()
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="flex w-full items-center border-b border-base bg-base">
        <HeaderTabs
          tabs={reportTabs}
          path="/allocation/reports"
          containerClassName="flex-1 border-b-0"
        />
      </div>
      <Outlet />
    </div>
  )
}
